import type { HighlightView } from "./Highlight";

// Клип в работе: заказан и ждёт ферму или пишется.
export const isClipWorking = (highlight: HighlightView): boolean =>
  highlight.clip.status === "queued" || highlight.clip.status === "rendering";

// Клип можно заказать: момент найден или запись сорвалась (сервер примет повтор только
// для `render_failed`; демку, которой нет, заказывать бессмысленно).
export const canRequestClip = (highlight: HighlightView): boolean =>
  highlight.clip.status === "found" ||
  (highlight.clip.status === "failed" && highlight.clip.error === "render_failed");

export const isClipReady = (highlight: HighlightView): boolean =>
  highlight.clip.status === "ready" && highlight.clip.video_url !== null;

// Лучший момент сначала, остальные — по порядку в матче.
export const byBestThenTime = (a: HighlightView, b: HighlightView): number =>
  Number(b.best) - Number(a.best) || a.game_time_s - b.game_time_s;

// Клип не сделать никогда: игра обновилась после матча или демки у Valve больше нет.
// Такие моменты не показываем — без клипа они мало что дают.
export const isClipHopeless = (highlight: HighlightView): boolean =>
  highlight.clip.status === "failed" &&
  (highlight.clip.error === "demo_outdated" || highlight.clip.error === "demo_unavailable");
